import { Injectable } from '@angular/core';
import {
  PackagingLevelDetailScenario,
  ProjectImportInfo,
  ProjectScope,
} from '@piqet-angular/shared';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'apps/piqet-angular/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AutomationDataService {
  apiUrl = environment.url;

  constructor(private http: HttpClient) {}

  getAllAutomationWorkflows() {
    return this.http.get<any>(`${this.apiUrl}/EmailConfiguration/GetAllAutomationWorkflows`);
  }

  getAutomationWorkflowById(id: any) {
    return this.http.get<any>(
      `${this.apiUrl}/EmailConfiguration/GetAutomationWorkflowById?workflowId=${id}`
    );
  }

  saveOrUpdateWorkflowSteps(data: any) {
    return this.http.post<any>(`${this.apiUrl}/EmailConfiguration/SaveOrUpdateWorkflowSteps`, data);
  }

  testAutomation(data: any) {
    return this.http.post<any>(`${this.apiUrl}/EmailConfiguration/TestAutomation`, data);
  }

  saveOrUpdateWorkflow(data: any) {
    return this.http.post<any>(`${this.apiUrl}/EmailConfiguration/SaveOrUpdateWorkflow`, data);
  }

  getAutomationStepsByUser(workflowId: any, requestType: any, userId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/EmailConfiguration/GetAutomationStepsByUser?workflowId=${workflowId}&requestType=${requestType}&userId=${userId}`
    );
  }

  getAllMasterEmailTemplates() {
    return this.http.get<any>(`${this.apiUrl}/EmailConfiguration/GetAllMasterEmailTemplates`);
  }

  saveOrUpdateEmailTemplate(data: any) {
    return this.http.post<any>(`${this.apiUrl}/EmailConfiguration/SaveOrUpdateEmailTemplate`, data);
  }

  getMasterEmailTemplateById(id: any) {
    return this.http.get<any>(
      `${this.apiUrl}/EmailConfiguration/GetMasterEmailTemplateById?templateId=${id}`
    );
  }

  getAutomationWorkflowAnalytics(data: any) {
    return this.http.post<any>(`${this.apiUrl}/EmailConfiguration/GetWorkflowAnalyticsAsync`, data);
  }

  resumeAutomationFromHold(data: any) {
    return this.http.post<any>(`${this.apiUrl}/EmailConfiguration/ResumeAutomationFromHold`, data);
  }
}
